function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import messages from '../../messages';
import styles from './ExternalDataSourcesIntro.pcss';
const ExternalDataSourcesIntro = ({ className })=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsx("p", {
        className: cn(styles.dataSourcesIntro, className),
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.dataSourcesSettings))
    });
};
export default /*#__PURE__*/ memo(ExternalDataSourcesIntro);
